import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/util/Button'
import { FormattedMessage, injectIntl } from 'react-intl'
import styles from './_toolbar.css'
import { Grid, Row, Col } from 'react-flexbox-grid/lib'

const propTypes = {
  showDirections: PropTypes.bool.isRequired,
  showElevation: PropTypes.bool.isRequired,
  showMap: PropTypes.bool.isRequired,
  toggleElevation: PropTypes.func.isRequired,
  toggleDirections: PropTypes.func.isRequired,
  toggleMap: PropTypes.func.isRequired,
  print: PropTypes.func.isRequired,
}

export function Toolbar (props) {
  return (
    <section className={styles.container}>
      <Grid>
        <Row middle='xs'>
          <Col xs={6}>
            <label className={styles.control}>
              <input type='checkbox' onChange={() => props.toggleMap()} checked={props.showMap} />
              <FormattedMessage id='routes.print.toolbar.printToggle' defaultMessage='Map' />
            </label>
            <label className={styles.control}>
              <input type='checkbox' onChange={() => props.toggleDirections()} checked={props.showDirections} />
              <FormattedMessage id='routes.print.toolbar.directionsToggle' defaultMessage='Directions' />
            </label>
            <label className={styles.control}>
              <input type='checkbox' onChange={() => props.toggleElevation()} checked={props.showElevation} />
              <FormattedMessage id='routes.print.toolbar.elevationToggle' defaultMessage='Elevation' />
            </label>
          </Col>
          <Col xs={4} xsOffset={2}>
            <Button el='button' onClick={() => props.print()} className={styles.button}>
              <FormattedMessage id='routes.print.toolbar.print' defaultMessage='Print' />
            </Button>
          </Col>
        </Row>
      </Grid>
    </section>
  )
}

Toolbar.propTypes = propTypes

export default injectIntl(Toolbar)
